import {FC} from "react";

export const CloseModalIcon: FC<{width?: number, height?: number, onClick?: () => void}> = ({width = 72, height = 72, onClick = () => {}}) => (
    <svg className={'close-modal-icon'} cursor="pointer" onClick={onClick} width={width} height={height} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M31.3816 35.9998L6 61.3791L10.6154 65.994L35.997 40.6147L61.3844 66L65.9998 61.385L40.6123 35.9998L65.9996 10.6149L61.3842 6L35.997 31.3849L10.6157 6.00585L6.00031 10.6208L31.3816 35.9998Z" fill="#909090"/>
    </svg>  
)

import {FC} from "react";

export const CloseModalIcon: FC<{width?: number, height?: number, onClick?: () => void}> = ({width = 72, height = 72, onClick = () => {}}) => (
    <svg className={'close-modal-icon'} cursor="pointer" onClick={onClick} width={width} height={height} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M31.3816 35.9998L6 61.3791L10.6154 65.994L35.997 40.6147L61.3844 66L65.9998 61.385L40.6123 35.9998L65.9996 10.6149L61.3842 6L35.997 31.3849L10.6157 6.00585L6.00031 10.6208L31.3816 35.9998Z" fill="#909090"/>
    </svg>  
)

